import createSlots from '../utils/create-slots'

export const {Slots, Slot} = createSlots(['Caption', 'Label', 'LeadingVisual', 'Validation'])
